import { css } from '@microsoft/fast-element';
import { neutralLayer1, getToken } from '../../design-tokens';
import { elevationRule } from '../../styles/elevation';
import { display } from '../../foundation/display';

// TODO: Break card from rectangle shape and re-add contain: content?
export const cardStyles = css`
        ${display('block')} :host {
            --elevation: ${getToken('space-default-elevation')};

            display: block;
            height: var(--card-height, auto);
            width: var(--card-width, 100%);
            box-sizing: border-box;
            background: ${neutralLayer1};
            border-radius: calc(${getToken('space-corner-radius')} * 1px);
            ${elevationRule}
        }
    `;
